module.exports = __webpack_public_path__ + "assets/queue-it.d91f5510.svg";